export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-500 via-primary-600 to-primary-700 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500/20 rounded-full -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-background-50/10 rounded-full translate-y-1/3 -translate-x-1/4"></div>

          <div className="relative flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-background-50/20 text-background-50 rounded-full mb-4">
                移动端观影
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                手机随时随地看大片
              </h2>
              <p className="text-sm text-background-50/80 max-w-md leading-relaxed">
                丫丫影院适配手机、平板、电脑全终端，无需下载APP，打开浏览器即可畅享高清影视。支持投屏播放，大屏追剧更过瘾。
              </p>
            </div>
            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-50/10 flex items-center justify-center">
                <i className="ri-smartphone-line text-5xl md:text-6xl text-background-50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}